import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd } from '@angular/router';
import { Observable, ReplaySubject ,  Subscription } from 'rxjs';

import { Breadcrumb } from './breadcrumb';
import { BreadcrumbFactoryInjector } from './breadcrumb.model';
import { RouterService } from 'src/cad/core/services/router/router.service';

import * as _ from 'lodash';

@Injectable()
export class BreadcrumbService {

  public breadcrumbs$: ReplaySubject<Breadcrumb[]> = new ReplaySubject<Breadcrumb[]>(1);

  private subscriptions: Subscription[] = [];

  private breadcrumbs: BreadcrumbHolder[] = [];

  constructor(
    private router: RouterService,
  ) {
    this.subscriptions.push(this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.disposeBreadcrumbs();
        this.collectBreadcrumbs(this.router.routerState.snapshot.root);
        this.emitBreadcrumbs();
      }
    }));
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  private emitBreadcrumbs(): void {
    this.breadcrumbs$.next(this.breadcrumbs.map((breadcrumb) => breadcrumb.breadcrumb));
  }

  private disposeBreadcrumbs(): void {
    this.breadcrumbs.forEach((breadcrumb) => {
      if (breadcrumb.subscription) { breadcrumb.subscription.unsubscribe(); }
    });
    this.breadcrumbs = [];
  }

  private collectBreadcrumbs(snapshot: ActivatedRouteSnapshot, lastCollected?: Breadcrumb | BreadcrumbFactoryInjector): void {
    if (snapshot.data && (snapshot.data as any).breadcrumb) {
      const breadcrumbData: Breadcrumb | BreadcrumbFactoryInjector = (snapshot.data as any).breadcrumb;
      if (!_.isEqual(breadcrumbData, lastCollected)) {
        let breadcrumbHolder: BreadcrumbHolder = { breadcrumb: { label: '' } };
        if ((breadcrumbData as Breadcrumb).label) {
          // plain old breadcrumb
          breadcrumbHolder = { breadcrumb: breadcrumbData as Breadcrumb };
        } else {
          // breadcrumb factory
          const breadcrumbFactoryInjector = breadcrumbData as BreadcrumbFactoryInjector;
          const breadcrumbFactory = breadcrumbFactoryInjector.get();
          const breadcrumbResult = breadcrumbFactory ? breadcrumbFactory.breadcrumb() : undefined;
          if (!breadcrumbFactory || !breadcrumbResult) {
            console.error('Failed to get breadcrumb factory result', { breadcrumbData });
          } else if ((breadcrumbResult as Breadcrumb).label) {
            // plain old breadcrumb
            breadcrumbHolder = { breadcrumb: breadcrumbResult as Breadcrumb };
          } else if ((breadcrumbResult as Observable<Breadcrumb>).subscribe) {
            // observable breadcrumb
            breadcrumbHolder.subscription = (breadcrumbResult as Observable<Breadcrumb>).subscribe((breadcrumb) => {
              if (!_.isEqual(breadcrumb, breadcrumbHolder.breadcrumb)) {
                breadcrumbHolder.breadcrumb = breadcrumb;
                this.emitBreadcrumbs();
              }
            });
          } else if ((breadcrumbResult as Promise<Breadcrumb>).then) {
            // promise breadcrumb
            (breadcrumbResult as Promise<Breadcrumb>).then((breadcrumb) => {
              if (!_.isEqual(breadcrumb, breadcrumbHolder.breadcrumb)) {
                breadcrumbHolder.breadcrumb = breadcrumb;
                this.emitBreadcrumbs();
              }
            });
          } else {
            console.error('Unrecognized breadcrumb data', { breadcrumbData, snapshot });
          }
        }
        this.breadcrumbs.push(breadcrumbHolder);
        /* tslint:disable:no-param-reassign */
        lastCollected = breadcrumbData;
        /* tslint:enable:no-param-reassign */
      }
    }
    for (let child of snapshot.children) {
      this.collectBreadcrumbs(child, lastCollected);
    }
  }
}

class BreadcrumbHolder {
  public breadcrumb: Breadcrumb;
  public subscription?: Subscription;
}
